import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Icon,
  IconButton,
  IconName,
  IconSize,
  Input,
  ProColors,
} from '@treatwell/treatwell-aura';
import { css } from '@emotion/react';
import { FormContextData, useFormContext } from '../../state';
import { useValidation } from './helpers/use-validation';

export function Password(): JSX.Element {
  const { t } = useTranslation('input', { keyPrefix: 'password' });
  const {
    data: { password },
    setData,
  } = useFormContext();
  const [visible, setVisible] = useState(false);

  const hasValue = useCallback(
    (data: FormContextData) =>
      data.password.length ? null : 'Password is empty',
    [],
  );
  const validate = useCallback(
    (data: FormContextData) =>
      data.password.length >= 8 ? null : 'Password is too short',
    [],
  );
  const extraInputProps = useValidation(t, hasValue, validate);

  const onValueChange = useCallback(
    (value: string) => {
      setData(current => ({ ...current, password: value }));
    },
    [setData],
  );

  const onToggleVisibility = useCallback(() => {
    setVisible(v => !v);
  }, []);

  return (
    <>
      <Input
        id="password"
        type={visible ? 'text' : 'password'}
        label={t('label')}
        value={password}
        onValueChange={onValueChange}
        {...extraInputProps}
        innerRightComponent={
          <IconButton
            name={visible ? IconName.TW_PRO_HIDE : IconName.TW_PRO_SHOW}
            size={IconSize.SMALL}
            color={ProColors.blue[600]}
            flavor="tertiary"
            onClick={onToggleVisibility}
            css={css({ marginRight: -8 })}
          />
        }
      />
      <div
        className="aura--copy-xs"
        css={css({
          color: ProColors.navy[500],
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          marginTop: 8,
          opacity: !extraInputProps.subText ? 1 : 0,
        })}
      >
        <Icon
          name={IconName.TW_PRO_CHECK_FILLED}
          size={IconSize.SMALL}
          color={ProColors.teal[600]}
        />
        {t('hint')}
      </div>
    </>
  );
}
